import { render, staticRenderFns } from "./ManageReservations.vue?vue&type=template&id=2bff5ca2&scoped=true"
import script from "./ManageReservations.vue?vue&type=script&lang=js"
export * from "./ManageReservations.vue?vue&type=script&lang=js"
import style0 from "./ManageReservations.vue?vue&type=style&index=0&id=2bff5ca2&prod&scoped=true&lang=css"
import style1 from "./ManageReservations.vue?vue&type=style&index=1&id=2bff5ca2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bff5ca2",
  null
  
)

export default component.exports